import { useEffect, useState } from "react";
import AuthContainer from "./AuthContainer";
import { Box } from "@mui/material";

type PageStates =
  | "login"
  | "forgot-password"
  | "check-mail"
  | "create-password"
  | "reset-password"
  | "verify-account";

interface AuthenticationPageProps {
  pageState?:
    | "login"
    | "forgot-password"
    | "check-mail"
    | "create-password"
    | "reset-password"
    | "verify-account";
}

function AuthenticationPage(props: Readonly<AuthenticationPageProps>) {
  // const [pageState, setPageState_] = useState<PageStates>('login');
  // const [pageState, setPageState_] = useState<PageStates>('forgot-password');
  // const [pageState, setPageState_] = useState<PageStates>('check-mail');
  // const [pageState, setPageState_] = useState<PageStates>('create-password');

  const initPage = props.pageState ?? "login";
  const [pageState, setPageState] = useState<PageStates>(initPage);
  useEffect(() => {
    setPageState(initPage);
  }, [initPage, pageState]);

  function onMainBtnClick() {
    if (pageState === "login") {
      // trigger login btn
      onLoginBtnClick();
    } else if (pageState === "create-password") {
      // trigger create password/account btn
      onCreatePasswordBtn();
    } else if (pageState === "forgot-password") {
      // trigger send password reset link btn
      onSendPasswordResetLinkBtn();
    } else if (pageState === "check-mail") {
      // trigger open email app btn
      onOpenEmailAppClick();
    } else if (pageState === "reset-password") {
      // trigger reset password btn
      onResetPasswordBtn();
    }
  }

  function onLabelButtonClick() {
    // Implement the logic for label button click if needed
    if (pageState === "login") {
      // trigger forgotten password
      onForgotPasswordClick();
    } else {
      setPageState("login");
    }
  }

  function onLoginBtnClick() {
    // Implement the logic to login
    // navigate('/');
    setPageState("create-password");
  }

  function onOpenEmailAppClick() {
    // Implement the logic to open the email app
    setPageState("reset-password");
  }

  function onSendPasswordResetLinkBtn() {
    // Implement the logic for forgot password
    setPageState("check-mail");
  }

  function onCreatePasswordBtn() {
    // Implement the logic to create a new password - account
    setPageState("login");
  }

  function onResetPasswordBtn() {
    // Implement the logic to reset password
    setPageState("login");
  }

  function onForgotPasswordClick() {
    setPageState("forgot-password");
  }


  const page_props = getPagePropValues({ pageState: pageState });
  return (
    <Box>
      <AuthContainer
        pageState={pageState}
        onMainBtnClick={onMainBtnClick}
        onLabelButtonClick={onLabelButtonClick}
        onOpenEmailAppClick={onOpenEmailAppClick}
        pageProps={page_props}
      />
    </Box>
  );
}

function getPagePropValues({ pageState }: { pageState: PageStates }) {
  switch (pageState) {
    case "login":
      return {
        BtnText: "Login",
        BtnType: "small",
        BtnIcon: true,
        pageTitle: "Login",
        infoLabelIconText: "Forgotten your password?",
        labelDirection: "right",
        userEmail: "",
      };
    case "forgot-password":
      return {
        BtnText: "Continue",
        BtnType: "medium",
        BtnIcon: false,
        pageTitle: "Forgot Password",
        pageSubtitle: "No worries, we will send you reset instructions",
        infoLabelIconText: "Go back to login",
        labelDirection: "left",
        userEmail: "",
      };
    case "check-mail":
      return {
        BtnText: "Open Email App",
        BtnType: "medium",
        BtnIcon: false,
        pageTitle: "Check your email",
        pageSubtitle: "We sent a password reset link to",
        infoLabelIconText: "Go back to login",
        labelDirection: "left",
        userEmail: "walterObrian@gmail.com",
      };
    case "create-password":
      return {
        BtnText: "Create Account",
        BtnType: "large",
        BtnIcon: true,
        pageTitle: "Create a new password",
        pageSubtitle: undefined,
        infoLabelIconText: "Cancel and go back",
        labelDirection: "right",
        userEmail: "",
      };
    case "reset-password":
      return {
        BtnText: "Reset Password",
        BtnType: "large",
        BtnIcon: false,
        pageTitle: "Create a new password",
        pageSubtitle: undefined,
        infoLabelIconText: "Cancel and go back",
        labelDirection: "left",
        userEmail: "",
      };
    default:
      return {
        BtnText: "Login",
        BtnType: "small",
        BtnIcon: true,
        pageTitle: "Verifying Your Account",
        pageSubtitle: "Please wait while we verify your account",
        infoLabelIconText: "Cancel and go back",
        labelDirection: "left",
        userEmail: "",
      };
  }
}

export default AuthenticationPage;
